import { createContext } from 'react';
import { BRAND_CONFIG } from '../../../utils/constants/commonConstants';

export const BrandContext = createContext(BRAND_CONFIG);
